import React, { FC } from 'react';
import { TableContainer, Table, TableBody, TableHead, TableRow, TableCell } from '@material-ui/core';
import { dummyPurchaseInvoiceItem } from 'utils/dummy';
import BodyRow from './components/BodyRow';
import PurchaseInvoiceItem from './components/PurchaseInvoiceItem';

interface Props {
  purchaseInvoiceItem: PurchaseInvoiceItemModel[];
  isLoading: boolean;
  handleSetValue: (value: PurchaseInvoiceItemModel) => void;
  handleOpenHistory: () => void;
  setProductId: (value: number) => void;
  historyResource: { createdAt: string; price: number; discount: number; totalItem: number; discountUnit?: number; orderDate: string }[];
}

const PurchaseOrderCreateTable: FC<Props> = props => {
  const { setProductId, purchaseInvoiceItem, isLoading, handleSetValue, handleOpenHistory, historyResource } = props;

  return (
    <TableContainer>
      <Table size='small'>
        <TableHead>
          <TableRow>
            <TableCell>Nama Produk</TableCell>
            <TableCell align='center'>Harga</TableCell>
            <TableCell align='center'>Qty</TableCell>
            <TableCell align='center'>Diskon</TableCell>
            <TableCell align='center'>Total Harga</TableCell>
            <TableCell align='center'>Modal Bersih</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {isLoading
            ? [1, 2, 3, 4].map(value => (
                <BodyRow key={value} item={dummyPurchaseInvoiceItem} isLoading={isLoading} handleOpenHistory={handleOpenHistory} />
              ))
            : purchaseInvoiceItem.length > 0 &&
              purchaseInvoiceItem
                .filter(value => !value.isDeleted)
                .map(value => (
                  <PurchaseInvoiceItem
                    item={value}
                    handleSetValue={handleSetValue}
                    handleOpenHistory={handleOpenHistory}
                    setProductId={setProductId}
                    historyResource={historyResource}
                  />
                ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default PurchaseOrderCreateTable;
